// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1525":"2626fe5a","3063":"ff863347","3077":"3efbc48c","5458":"3efbc48c"}[chunkId] + ".chunk.css";
};